const measurementUnitHu = {
	measurementUnitTable: 'Mértékegység',
	measurementUnitEditForm: 'Mértékegység',
	name: 'Név',
	created: 'Létrehozva',
	updated: 'Módosítva'
};

export default measurementUnitHu;
